(function () {
    'use strict';

    run.admin.parts.rackootAdsTiles = function() {
        const tilesAds = document.querySelectorAll('.tile_adffi');
        const tilesAdsDismiss = document.querySelectorAll('.tile_adffi .adtile_dismiss');
        if (tilesAdsDismiss.length == 0) {
            return;
        }

        for (let i = 0; i < tilesAds.length; i++) {
        }

        for (let i = 0; i < tilesAds.length; i++) {
            tilesAds[i].addEventListener('click', function(e) {
                Swal.fire({
                    title: '',
                    html: translations.ads.dismissButtonText,
                    showCloseButton: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    focusCancel: true,
                    cancelButtonText: translations.confirmAlerts.close,
                    confirmButtonText: translations.confirmAlerts.getProAccount,
                    buttonsStyling: false,
                    reverseButtons: true,
                    customClass: {
                        cancelButton: 'btn btn-light',
                        confirmButton: 'btn btn-primary ms-4'
                    },
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    }
                }).then((result) => {
                    if (result.value) {
                        window.location = GlobalRoutes.plan.dashboard;
                    }
                });
            });
        }
    };
})();
